import { MobileApp } from 'modules/mobileApps/types';
import { match } from 'ts-pattern';
import { colors } from 'ui/theme';
import { SETTINGS_DISPLAY_CONTENT } from '../../EditInApp/constants';

export const DESTINATION_SELECTOR_MODAL_CONTENT = SETTINGS_DISPLAY_CONTENT.destinations;

export const getAppNamesList = (list: MobileApp[]) => list?.map((app) => app.name).join(', ');

export const getRokuBodyText = (rokuApps: MobileApp[]) =>
  rokuApps ? `${DESTINATION_SELECTOR_MODAL_CONTENT.roku.body}: ${getAppNamesList(rokuApps)}` : '';

export const getAppAndBrowserBodyText = (mobileAppsAndWebsites: MobileApp[]) =>
  mobileAppsAndWebsites
    ? `${DESTINATION_SELECTOR_MODAL_CONTENT.appAndBrowser.body}: ${getAppNamesList(
        mobileAppsAndWebsites,
      )}`
    : '';

export const getHasApps = (apps: MobileApp[]) => apps?.length > 0;

export const sortMobileAppsByName = (list: MobileApp[]): MobileApp[] => {
  if (list.length > 2) return list;

  return list.sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });
};

export const getTargetCheckboxBorderColor = ({
  hasError,
  selected,
}: {
  hasError: boolean;
  selected: boolean;
}) =>
  match({ hasError, selected })
    .with({ selected: true }, () => colors.green50)
    .with({ hasError: true }, () => colors.red50)
    .otherwise(() => colors.grey15);
